import "./VehiclesDetailsImage.scss";

import { useEffect } from "react";

import Clear from "@mui/icons-material/Clear";
import ChevronRight from "@mui/icons-material/ChevronRight";
import ChevronLeft from "@mui/icons-material/ChevronLeft";

const VehiclesDetailsImage = ({ previewImages = [], index, setIndex, onClose }) => {
    const currentImage = previewImages[index];
    const src = currentImage?.src || null;

    const prev = (e) => {
        e?.stopPropagation?.();
        setIndex((i) => (i - 1 + previewImages.length) % previewImages.length);
    };

    const next = (e) => {
        e?.stopPropagation?.();
        setIndex((i) => (i + 1) % previewImages.length);
    };

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === "Escape") onClose();
            if (previewImages.length <= 1) return;
            if (e.key === "ArrowLeft") prev(e);
            if (e.key === "ArrowRight") next(e);
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [previewImages.length, onClose]);

    if (!src) return null;

    return (
        <div className="vehicles-details-image" onClick={onClose} role="dialog" aria-modal="true">
            <div className="vehicles-details-image_container" onClick={(e) => e.stopPropagation()}>
                <button
                    className="vehicles-details-image_close"
                    type="button"
                    onClick={onClose}
                    aria-label="Закрыть"
                >
                    <Clear />
                </button>

                <img src={src} className="vehicles-details-image_img" alt="Preview" />

                {previewImages.length > 1 && (
                    <>
                        <button
                            className="vehicles-details-image_nav vehicles-details-image_navLeft"
                            type="button"
                            onClick={prev}
                            aria-label="Предыдущее фото"
                        >
                            <ChevronLeft />
                        </button>

                        <button
                            className="vehicles-details-image_nav vehicles-details-image_navRight"
                            type="button"
                            onClick={next}
                            aria-label="Следующее фото"
                        >
                            <ChevronRight />
                        </button>

                        <div className="vehicles-details-image_counter">
                            {index + 1} / {previewImages.length}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default VehiclesDetailsImage;